import axios from "axios";
import { getSessionId } from "./session";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const MAX_FILE_BYTES = 20 * 1024 * 1024;

const ALLOWED_EXTS = new Set([".pdf", ".jpg", ".jpeg", ".png", ".heic", ".heif"]);
const ALLOWED_TYPE_PREFIXES = ["application/pdf", "image/"];

export function isSupportedFile(file) {
  if (!file) return false;
  const name = (file.name || "").toLowerCase();
  const ext = name.slice(name.lastIndexOf("."));
  const type = (file.type || "").toLowerCase();
  const extOk = ALLOWED_EXTS.has(ext);
  const typeOk =
    !type ||
    type === "application/octet-stream" ||
    ALLOWED_TYPE_PREFIXES.some((p) => type.startsWith(p));
  return extOk && typeOk;
}

// Kept for backwards-compat with older imports.
export const isPdfFile = isSupportedFile;

export async function uploadPolicy(file, { onProgress } = {}) {
  const sessionId = getSessionId();
  const form = new FormData();
  form.append("file", file, file.name);

  const res = await axios.post(`${API}/uploads`, form, {
    headers: { "X-Session-Id": sessionId },
    onUploadProgress: (e) => {
      if (!e.total) return;
      onProgress?.(Math.round((e.loaded / e.total) * 100));
    },
    timeout: 120000,
  });
  return res.data;
}

export async function listSessionUploads() {
  const sessionId = getSessionId();
  const res = await axios.get(`${API}/uploads`, {
    headers: { "X-Session-Id": sessionId },
  });
  return res.data;
}

export function downloadUrl(fileId) {
  const sessionId = getSessionId();
  return `${API}/uploads/${fileId}/download?s=${encodeURIComponent(sessionId)}`;
}

export function reportPdfUrl(fileId) {
  const sessionId = getSessionId();
  return `${API}/uploads/${fileId}/report.pdf?s=${encodeURIComponent(sessionId)}`;
}

export async function deleteUpload(fileId) {
  const sessionId = getSessionId();
  const res = await axios.delete(`${API}/uploads/${fileId}`, {
    headers: { "X-Session-Id": sessionId },
  });
  return res.data;
}

export async function deleteAllSessionUploads() {
  const sessionId = getSessionId();
  const res = await axios.delete(`${API}/uploads`, {
    headers: { "X-Session-Id": sessionId },
  });
  return res.data;
}

export async function recordUploadConsentServer({ version = "v1" } = {}) {
  const sessionId = getSessionId();
  const res = await axios.post(
    `${API}/consent/upload`,
    { version, accepted_at: new Date().toISOString() },
    { headers: { "X-Session-Id": sessionId } },
  );
  return res.data;
}
